import { SEOMetaDescriptorsBuilder } from "@basaltbytes/web-utils/seo/metadata";

export const SEOMetaDescriptors = SEOMetaDescriptorsBuilder(ENV.PUBLIC_APP_URL);
